export interface GetDateTimeParams {
  date?: Date;
  hours?: number;
  seconds?: number;
  minutes?: number;
  milliseconds?: number;
  timezoneOffset?: number;
  toUTC?: boolean;
}

export const getDateTime = ({
  date,
  hours,
  seconds,
  minutes,
  milliseconds,
  timezoneOffset,
  toUTC,
}: GetDateTimeParams): Date => {
  const d = date ? new Date(date) : new Date();
  if (hours !== undefined) d.setHours(hours);
  if (timezoneOffset !== undefined) {
    const currentLocalOffset = -d.getTimezoneOffset() / 60;
    if (timezoneOffset !== currentLocalOffset)
      d.setHours(
        d.getHours() +
          (toUTC
            ? -timezoneOffset + currentLocalOffset
            : -currentLocalOffset + timezoneOffset),
      );
  }
  if (minutes !== undefined) d.setMinutes(minutes);
  if (seconds !== undefined) d.setSeconds(seconds);
  if (milliseconds !== undefined) d.setMilliseconds(milliseconds);

  return d;
};
